import { RootState } from 'handlers';

export const getYourNameData = ({ yourName }: RootState) => yourName;
